import type { SdkWithExperimentSnippets } from './types';

interface SnippetConfig {
  event: string;
  title: string;
}

export const experimentationSnippetConfig: Record<SdkWithExperimentSnippets, SnippetConfig> = {
  'android-client-sdk': { event: 'android-client-experimentation', title: 'Kotlin' },
  'ios-client-sdk': { event: 'ios-client-experimentation', title: 'Swift' },
  'js-client-sdk': { event: 'js-client-experimentation', title: 'JavaScript' },
  'react-client-sdk': { event: 'react-client-experimentation', title: 'TSX' },
  'react-native-client-sdk': { event: 'react-native-client-experimentation', title: 'TSX' },
};
